import {Branding} from "@irati/types"
import {QueryBrandingArgs, MutationUpdateBrandingArgs, UpdateBrandingInput} from "@irati/types/ops"
import client, {QueryOptions, MutationOptions} from "@irati/utils/services/apollo"
import PBService from "@irati/utils/services"
import authentication from "@irati/auth"

import brandingQuery, {brandingKey} from "./queries/branding"
import updateBrandingMutation, {updateBrandingKey} from "./mutations/brandingUpdate"

class BrandingService extends PBService {
  private getBranding(variables: QueryBrandingArgs, options: QueryOptions) {
    return client.query({...options, query: brandingQuery, variables}).then((res) => res.data[brandingKey])
  }

  getForTeam(teamId: string, options: QueryOptions = {}): Promise<Branding> {
    const variables: QueryBrandingArgs = {
      businessId: authentication.userTenant().uuid,
      teamId
    }
    return this.getBranding(variables, options)
  }

  get(options: QueryOptions = {}): Promise<Branding> {
    const variables: QueryBrandingArgs = {
      businessId: authentication.userTenant().uuid,
      userId: authentication.user().uuid
    }
    return this.getBranding(variables, options)
  }

  update(data: UpdateBrandingInput, options: MutationOptions = {}) {
    const variables: MutationUpdateBrandingArgs = {
      data
    }

    return client.mutate({...options, mutation: updateBrandingMutation, variables}).then((res) => res.data[updateBrandingKey])
  }
}

export default new BrandingService({errorHandlers: []})
